import { Component } from "react"
import { Container, Row, Col } from "reactstrap"
import { withTranslation } from 'react-i18next'
import Slider from "react-slick"
import { isMobile } from "react-device-detect"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

class AvisVideo extends Component {
  render() {
    const { t } = this.props

    const videos = [
      {
        name: "Delphine",
        url: "https://www.youtube.com/embed/XUDQLaWwkPE"
      },
      {
        name: "Marie L.",
        url: "https://www.youtube.com/embed/7qnJrTBacMs"
      },
      {
        name: "Adrien",
        url: "https://www.youtube.com/embed/MTc1kgncs7Y"
      }
    ]

    const sliderSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true
    }

    return (
      <div className="py-5">
        <Container>
          <h2 className="mb-5 text-center dark-blue">{t("Témoignages vidéos")}</h2>

          {isMobile ? (
            <Slider {...sliderSettings}>
              {videos.map((video, index) => (
                <div key={index} className="text-center px-2">
                  <div className="video-wrapper mb-3">
                    <iframe
                      width="100%"
                      height="215"
                      src={video.url}
                      title={`Avis de ${video.name}`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                  <p>{video.name}</p>
                </div>
              ))}
            </Slider>
          ) : (
            <Row className="text-center">
              {videos.map((video, index) => (
                <Col md={4} key={index} className="mb-4">
                  <div className="video-wrapper mb-3">
                    <iframe
                      width="100%"
                      height="215"
                      src={video.url}
                      title={`Avis de ${video.name}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                  <p>{video.name}</p>
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </div>
    )
  }
}

export default withTranslation("avisclients")(AvisVideo)

